import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    flex: 1,
    minHeight: 0,
    overflow: 'scroll' as const,
    backgroundColor: white,
  },
  content: {
    paddingBottom: 60,
  },
});
